import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Building2, LayoutDashboard } from "lucide-react";
import SuperAdminDashboard from "./SuperAdminDashboard";
import TenantDashboard from "@/components/TenantDashboard";

export default function DashboardPage({ user }) {
  const [viewMode, setViewMode] = useState(user?.is_superadmin && user?.current_tenant_id ? "tenant" : (user?.is_superadmin ? "global" : "tenant"));

  if (user?.is_superadmin) {
    return (
      <>
        <div className="page-container pb-0 mb-0">
          <div className="flex gap-2 mb-4">
            <Button
              variant={viewMode === "global" ? "default" : "outline"}
              size="sm"
              onClick={() => setViewMode("global")}
              className={viewMode === "global" ? "bg-indigo-600 hover:bg-indigo-700 text-white" : ""}
              data-testid="toggle-global-view"
            >
              <Building2 size={14} className="mr-1.5" /> Vue globale
            </Button>
            <Button
              variant={viewMode === "tenant" ? "default" : "outline"}
              size="sm"
              onClick={() => setViewMode("tenant")}
              className={viewMode === "tenant" ? "bg-indigo-600 hover:bg-indigo-700 text-white" : ""}
              data-testid="toggle-tenant-view"
            >
              <LayoutDashboard size={14} className="mr-1.5" /> Ma société
            </Button>
          </div>
        </div>
        {viewMode === "global" ? <SuperAdminDashboard /> : <TenantDashboard user={user} />}
      </>
    );
  }

  return <TenantDashboard user={user} />;
}
